import React, { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Cookies from "js-cookie";
import { notifysuccess } from "../utils/toast";
import { notifyfailure } from "../utils/toast";
import constantMessage from "../constants/constantMsg.json";
import { isExpired } from "react-jwt";
import { jwtDecode } from "jwt-decode";
import { useLocation } from "react-router-dom";
// import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import { Row, Col } from "antd";
import logoutIcon from "../assets/images/icons/log-out.svg";
import dashboardIcon from '../assets/images/header/icons/dashboard.svg';
import inventIcon from '../assets/images/header/icons/invent_icon.svg';
// import usersIcon from '../assets/images/header/icons/users.svg';
// import helpcircleIcon from '../assets/images/header/icons/help-circle.svg';
// import briefcaseIcon from '../assets/images/header/icons/briefcase.svg';
// import settingIcon from '../assets/images/header/icons/settings.svg';
// import reportIcon from '../assets/images/header/icons/reports.svg';
// import zoneIcon from '../assets/images/header/icons/zone_icon.svg';
import InventoryIcon from '../assets/images/header/icons/Inventory_icon.svg';
import reportIcon2 from '../assets/images/header/icons/reports2.svg';
import adminIcon from '../assets/images/header/icons/admin_icon.svg';
import ToolsIcon from '../assets/images/header/icons/Tools.svg';
import partnersIcon from '../assets/images/header/icons/demand.svg';
import ListManagerIcon from '../assets/images/header/icons/list_manager.svg';
import MediaMlannerIcon from '../assets/images/header/icons/media_planner.svg';
// import listbreadcrumbsIcon from '../assets/images/icons/list_breadcrumbs.svg';
// import listIcon from '../assets/images/icons/list_icon.svg';
// import AdTxt from '../assets/images/header/icons/adtxt.svg';
import HeaderArrow from '../assets/images/header/icons/header_droparrow.svg';
import compatibleImg from "../assets/images/compatible.svg";
import blackLogo from "../assets/logo/helix_black_logo_with_xapads.svg"
import whiteLogo from "../assets/logo/new_helix_logo.svg"
import { useOnboardingStep } from '../context/OnboardingStepContext';


const Header = () => {
  // eslint-disable-next-line no-unused-vars
  const { internalStep, currentStep, pubStatus, registerStep, registerInternalStep, msgInventory } = useOnboardingStep();
  const location = useLocation();
  const [loggedin, setLoggedin] = useState(false);
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [checkRole, setCheckRole] = useState("admin");
  // const [heading, setHeading] = useState("");


  const logout = () => {
    notifysuccess(constantMessage.Logout_MSG);

    setTimeout(() => {
      Cookies.remove("token_xapads_ssp");
      window.location.replace("/login");
    }, 1000);
  };

  useEffect(() => {
    const tokenExpired = async () => {
      let status = Cookies.get("token_xapads_ssp") ? true : false;
      if (status) {
        let token = Cookies.get("token_xapads_ssp");
        const isMyTokenExpired = isExpired(token);
        if (isMyTokenExpired) {
          notifyfailure("Token Expired! Signing Out");
          setTimeout(() => {
            Cookies.remove("token_xapads_ssp");
            window.location.replace("/login");
          }, 1500);
        }
      }
    };

    const timeoutId = setTimeout(() => {
      tokenExpired();
      const intervalId = setInterval(tokenExpired, 15000); // Call every 15 sec
      return () => clearInterval(intervalId);
    }, 10000);
    return () => clearTimeout(timeoutId);
  }, []);

  useEffect(() => {
    const accountCheck = async () => {
      if (email !== "") {
        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
          let token = Cookies.get("token_xapads_ssp");
          let emailToken = jwtDecode(token).email;
          if (emailToken !== email) {
            window.location.reload();
          }
        } else {
          window.location.reload();
        }
      } else {
        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
          window.location.reload();
        }
      }
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        accountCheck();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => document.removeEventListener("visibilitychange", handleVisibilityChange);
  });

  useEffect(() => {
    let status = Cookies.get("token_xapads_ssp") ? true : false;
    setLoggedin(status);

    if (status) {
      let token = Cookies.get("token_xapads_ssp");
      if (token) {
        setEmail(jwtDecode(token)?.email);
        setName(jwtDecode(token)?.p_name)
        setCheckRole(jwtDecode(token)?.role);
      }
    }
  }, [location.pathname]);

  return (
    <>
      <ToastContainer />
      {(location.pathname === "/signup-onboarding" || location.pathname === "/signup-inventory") && !loggedin &&
        registerStep === 2 && (
          <header>
            <div className="compatible_content">
              <img src={blackLogo} alt="USP" className="logo" />
              <img src={compatibleImg} alt="compatible" className="w_100" />
              {/* <button className="logout_compatible" onClick={logout}>Logout</button> */}
            </div>

            <div className="container_box--header">
              <Row gutter={16} className='w-100 p-0'

              >
                <Col span={22} className='container_box--end p-0' style={{ justifyContent: "flex-start" }}>
                  <Link className='logo'>
                    <img

                      src={whiteLogo}
                      alt='USP' />
                  </Link>
                  {(registerStep >= 2) &&
                    <nav>
                      <ul>

                        <li ><Link to="/signup-onboarding" className={location.pathname === "/signup-onboarding" ? "active" : ""}><img src={dashboardIcon} alt='Dashboard' /> Onboarding</Link></li>

                        {/* {registerInternalStep >= 4 && */}
                        <li  >
                          <Link to="/signup-inventory" className={location.pathname === "/signup-inventory" ? "active" : ""}><img src={inventIcon} alt='Dashboard' /> Inventory</Link></li>
                        {/* } */}
                      </ul>
                    </nav>
                  }



                </Col>
                <Col span={2} className='container_box--end p-0' style={{ justifyContent: "flex-end" }}>
                  {/* <div className="user_dropdown">
                  <div className='user_dropdown--symbol'>
                    <span>{name?.length > 0 ? name?.charAt(0)?.toUpperCase() : ""}</span>
                    <div className="user_dropdown--menu">
                      <div className="user_dropdown--menu-header">
                        <h4 className='heading'>{name.toUpperCase()}</h4>
                        <p className='text'>{email.toLowerCase()}</p>
                      </div>

                      <div className="user_dropdown--menu-footer py-0">
                        <button className="menu_item" onClick={logout}><img src={logoutIcon} alt="USP" /> Logout</button>
                      </div>
                    </div>
                  </div>
                </div> */}
                </Col>
              </Row>
            </div>

          </header>
        )}
      {loggedin && (pubStatus === "new" || pubStatus === "onboard" || pubStatus === "rejected") && (
        <header>
          <div className="compatible_content">
            <img src={blackLogo} alt="USP" className="logo" />
            <img src={compatibleImg} alt="compatible" className="w_100" />
            <button className="logout_compatible" onClick={logout}>Logout</button>
          </div>
          <div className="container_box--header">
            <Row gutter={16} className='w-100 p-0'

            >
              <Col span={22} className='container_box--end p-0' style={{ justifyContent: "flex-start" }}>
                <Link to="/onboarding" className='logo'><img

                  src={whiteLogo}
                  alt='USP' /></Link>

                {(currentStep >= 2) &&
                  <nav>
                    <ul>

                      <li><Link to="/onboarding" className={location.pathname === "/onboarding" ? "active" : ""}><img src={dashboardIcon} alt='Dashboard' /> Onboarding</Link></li>
                      {/* {(pubStatus === "onboard" || pubStatus === "rejected") &&
                        internalStep >= 4 && */}
                      <li><Link to="/inventory" className={location.pathname === "/inventory" ? "active" : ""}><img src={inventIcon} alt='Dashboard' /> Inventory</Link></li>
                      {/* } */}
                    </ul>
                  </nav>
                }



              </Col>
              <Col span={2} className='container_box--end p-0' style={{ justifyContent: "flex-end" }}>
                <div className="user_dropdown">
                  <div className='user_dropdown--symbol'>
                    <span>{name?.length > 0 ? name?.charAt(0)?.toUpperCase() : ""}</span>
                    <div className="user_dropdown--menu">
                      <div className="user_dropdown--menu-header">
                        <h4 className='heading'>{name.toUpperCase()}</h4>
                        <p className='text'>{email.toLowerCase()}</p>
                      </div>

                      <div className="user_dropdown--menu-footer py-0">
                        <button className="menu_item" onClick={logout}><img src={logoutIcon} alt="USP" /> Logout</button>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </header>
      )}
      {loggedin && (pubStatus === "approved" || pubStatus === "declined" || pubStatus === "archived") && (
        <>
          <header>
            <div className="compatible_content">
              <img
                src={blackLogo}
                alt="USP" className="logo" />
              <img src={compatibleImg} alt="compatible" className="w_100" />
              <button className="logout_compatible" onClick={logout}>Logout</button>
            </div>
            <div className="container_box--header">
              <Row gutter={16} className='w-100 p-0'>
                <Col span={22} className='container_box--logo'>

                  <Link to="/dashboard" className='logo'><img
                    src={whiteLogo}
                    alt='USP' /></Link>

                  <nav>
                    <ul>

                      <li><Link to="/dashboard" className={location.pathname === "/dashboard" ? "active" : ""}><img src={dashboardIcon} alt='Dashboard' /> Dashboard</Link></li>


                      {<li><Link className={location.pathname === "/inventory" || location.pathname === "/zoneList" || location.pathname === "/publisherList" ? "active" : ""}><img src={InventoryIcon} alt='inventory' /> Inventory
                        <img src={HeaderArrow} className="hoverarrow" alt="" />
                        <div className="custom_drop_down_d2">
                          <ul className="">
                            {((checkRole !== "admin" && checkRole !== "u_admin")) &&
                              <li className={location.pathname === "/publisherList" ? "active_menu_item_d2 submenu_item" : "submenu_item"}>
                                <Link to="/publisherList">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <path d="M13.3333 4.66667H2.66668C1.9303 4.66667 1.33334 5.26363 1.33334 6.00001V12.6667C1.33334 13.4031 1.9303 14 2.66668 14H13.3333C14.0697 14 14.6667 13.4031 14.6667 12.6667V6.00001C14.6667 5.26363 14.0697 4.66667 13.3333 4.66667Z" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M10.6667 14V3.33333C10.6667 2.97971 10.5262 2.64057 10.2762 2.39052C10.0261 2.14048 9.68697 2 9.33334 2H6.66668C6.31305 2 5.97392 2.14048 5.72387 2.39052C5.47382 2.64057 5.33334 2.97971 5.33334 3.33333V14" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                  </svg>
                                  Publishers
                                </Link>

                              </li>
                            }

                            {/* {((checkRole !== "admin" && checkRole !== "u_admin")) && */}
                            <li className={location.pathname === "/zoneList" ? "active_menu_item_d2" : ""}>
                              <Link to="/zoneList">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                  <g clip-path="url(#clip0_10781_28302)">
                                    <path d="M8.00001 14.6667C11.6819 14.6667 14.6667 11.6819 14.6667 7.99999C14.6667 4.3181 11.6819 1.33333 8.00001 1.33333C4.31811 1.33333 1.33334 4.3181 1.33334 7.99999C1.33334 11.6819 4.31811 14.6667 8.00001 14.6667Z" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M14.6667 8H12" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M4.00001 8H1.33334" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M8 3.99999V1.33333" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M8 14.6667V12" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_10781_28302">
                                      <rect width="16" height="16" fill="white" />
                                    </clipPath>
                                  </defs>
                                </svg>
                                Zones
                              </Link>
                            </li>
                            {/* } */}
                            {(pubStatus === "approved" || pubStatus === "archived" || pubStatus === "declined") &&
                              <li className={location.pathname === "/inventory" ? "active_menu_item_d2" : ""}>
                                <Link to="/inventory">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <g clip-path="url(#clip0_10781_28667)">
                                      <path d="M8.00001 14.6667C11.6819 14.6667 14.6667 11.6819 14.6667 7.99999C14.6667 4.3181 11.6819 1.33333 8.00001 1.33333C4.31811 1.33333 1.33334 4.3181 1.33334 7.99999C1.33334 11.6819 4.31811 14.6667 8.00001 14.6667Z" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                      <path d="M1.33334 8H14.6667" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                      <path d="M8.00001 1.33333C9.66753 3.1589 10.6152 5.52802 10.6667 7.99999C10.6152 10.472 9.66753 12.8411 8.00001 14.6667C6.33249 12.8411 5.38484 10.472 5.33334 7.99999C5.38484 5.52802 6.33249 3.1589 8.00001 1.33333V1.33333Z" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_10781_28667">
                                        <rect width="16" height="16" fill="white" />
                                      </clipPath>
                                    </defs>
                                  </svg>
                                  Sites & Apps
                                </Link>
                              </li>
                            }

                          </ul>
                        </div>
                      </Link></li>}

                      {((checkRole !== "admin" && checkRole !== "u_admin") && checkRole !== "am") && <li><Link className={(location.pathname === "/reporting" || location.pathname === "/reportingV1") ? "active" : ""}><img src={reportIcon2} alt='inventory' /> Analytics
                        <img src={HeaderArrow} className="hoverarrow" alt="" />
                        <div className="custom_drop_down_d2">
                          <ul className="">
                            <li className={location.pathname === "/reporting" ? "active_menu_item_d2" : ""}><Link to="/reporting">
                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M2.12 13.63V8.59H6.04" stroke="black" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M15 13.63H1" stroke="black" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M6.04004 13.63V5.23H9.96004" stroke="black" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M13.88 1.87H9.95996V13.63H13.88V1.87Z" stroke="black" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                              Reports
                            </Link>
                            </li>
                            <li className={location.pathname === "/reportingV1" ? "active_menu_item_d2" : ""}><Link to="/reportingV1">
                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M14 13H2V3" stroke="black" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M13 4L8 9L6 7L2 11" stroke="black" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M13 6.5V4H10.5" stroke="black" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                              Reports (Old)
                            </Link>
                            </li>

                          </ul>
                        </div>
                      </Link></li>}

                      {((checkRole === "admin" || checkRole === "u_admin") || checkRole === "am") &&
                        <li><Link to="/reporting" className={location.pathname === "/reporting" ? "active" : ""}><img src={reportIcon2} alt='report' /> Reports</Link></li>
                      }

                      {((checkRole !== "admin" && checkRole !== "u_admin")) && (<li><Link className={location.pathname === "/domainsMediaPlanner" || location.pathname === "/ctvMediaPlanner"
                        ? "active" : ""}><img src={MediaMlannerIcon} alt='demand' /> Media Planner
                        <img src={HeaderArrow} className="hoverarrow" alt="" />
                        <div className="custom_drop_down_d2">
                          <ul className="">

                            <>
                              {/* <li className="submenu_item"><Link to="#">Media Planner <img src={HeaderArrow} className="hoverarrow" alt="" /></Link>
                                <div className="custom_drop_down_d3">
                                  <ul className="">

                                  </ul>
                                </div>
                              </li> */}
                              {/* <span className="menu_heading_with_divider" style={{ padding: '0.8rem 1.4rem' }}>MEDIA PLANNER</span> */}
                              <li className={location.pathname === "/domainsMediaPlanner" ? "active_menu_item_d2" : ""}>
                                <Link to="/domainsMediaPlanner">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <g clip-path="url(#clip0_10781_28663)">
                                      <path d="M6.00002 11.3333H4.00002C3.56228 11.3333 3.12883 11.2471 2.72441 11.0796C2.31999 10.9121 1.95253 10.6666 1.643 10.357C1.01788 9.73191 0.666687 8.88406 0.666687 8C0.666687 7.11595 1.01788 6.2681 1.643 5.64298C2.26812 5.01786 3.11597 4.66667 4.00002 4.66667H6.00002M10 4.66667H12C12.4378 4.66667 12.8712 4.75289 13.2756 4.92041C13.6801 5.08792 14.0475 5.33345 14.357 5.64298C14.6666 5.95251 14.9121 6.31998 15.0796 6.72439C15.2471 7.12881 15.3334 7.56227 15.3334 8C15.3334 8.43774 15.2471 8.8712 15.0796 9.27562C14.9121 9.68003 14.6666 10.0475 14.357 10.357C14.0475 10.6666 13.6801 10.9121 13.2756 11.0796C12.8712 11.2471 12.4378 11.3333 12 11.3333H10V4.66667Z" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                      <path d="M5.33331 8H10.6666" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_10781_28663">
                                        <rect width="16" height="16" fill="white" />
                                      </clipPath>
                                    </defs>
                                  </svg>
                                  Domains
                                </Link>
                              </li>
                              <li className={location.pathname === "/ctvMediaPlanner" ? "active_menu_item_d2" : ""}>
                                <Link to="/ctvMediaPlanner">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <path d="M13.9583 2H2.04167C1.74251 2 1.5 2.23703 1.5 2.52941V10.4706C1.5 10.763 1.74251 11 2.04167 11H13.9583C14.2575 11 14.5 10.763 14.5 10.4706V2.52941C14.5 2.23703 14.2575 2 13.9583 2Z" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M3.5 8C3.76522 8 4.01957 8.10536 4.20711 8.29289C4.39464 8.48043 4.5 8.73478 4.5 9" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M3.5 6C4.29565 6 5.05871 6.31607 5.62132 6.87868C6.18393 7.44129 6.5 8.20435 6.5 9" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M3.5 4C4.15661 4 4.80679 4.12933 5.41342 4.3806C6.02005 4.63188 6.57124 5.00017 7.03553 5.46447C7.49983 5.92876 7.86812 6.47996 8.1194 7.08658C8.37067 7.69321 8.5 8.34339 8.5 9" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <line x1="4.7" y1="13.3" x2="11.3" y2="13.3" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" />
                                  </svg>
                                  CTV
                                </Link>
                              </li>
                              {/* <hr className="new_item_line_d2" /> */}
                            </>
                          </ul>
                        </div>
                      </Link></li>)}

                      <li><Link className={location.pathname === "/adsTxt" || location.pathname === "/brandSafety" || location.pathname === "/basicSettings" || location.pathname === "/accountSettings" || location.pathname === "/generalSettings" || location.pathname === "/inventorySettings" || location.pathname === "/adsTxtListing" || location.pathname === "/adsTxtView" || location.pathname === "/appAdsTxtView" ? "active" : ""}><img src={ToolsIcon} alt='settings' /> Settings
                        <img src={HeaderArrow} className="hoverarrow" alt="" />
                        <div className="custom_drop_down_d2">
                          <ul className="">
                            {(checkRole !== "admin" && checkRole !== "u_admin") &&
                              <>
                                <li className={location.pathname === "/adsTxtListing" ? "active_menu_item_d2" : ""}>
                                  <Link to="/adsTxtListing">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                      <g clip-path="url(#clip0_11459_19094)">
                                        <path d="M13.0556 1.5H2.94444C2.1467 1.5 1.5 2.1467 1.5 2.94444V13.0556C1.5 13.8533 2.1467 14.5 2.94444 14.5H13.0556C13.8533 14.5 14.5 13.8533 14.5 13.0556V2.94444C14.5 2.1467 13.8533 1.5 13.0556 1.5Z" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M5.11072 4.75H10.8885" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M5.11072 8H10.8885" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M5.11072 11.25H10.8885" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_11459_19094">
                                          <rect width="16" height="16" fill="white" />
                                        </clipPath>
                                      </defs>
                                    </svg>
                                    Ads.txt
                                  </Link>
                                </li>
                                <li className={location.pathname === "/inventorySettings" ? "active_menu_item_d2" : ""}>
                                  <Link to="/inventorySettings">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                      <g clip-path="url(#clip0_11459_20470)">
                                        <path d="M8.00004 1.33333L1.33337 4.66666L8.00004 7.99999L14.6667 4.66666L8.00004 1.33333Z" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M1.33337 11.3333L8.00004 14.6667L14.6667 11.3333" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M1.33337 8L8.00004 11.3333L14.6667 8" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_11459_20470">
                                          <rect width="16" height="16" fill="white" />
                                        </clipPath>
                                      </defs>
                                    </svg>
                                    Inventory Settings
                                  </Link>
                                </li>
                              </>
                            }

                            {(checkRole === "admin" || checkRole === "u_admin") &&
                              <>
                                <li className={location.pathname === "/adsTxtView" ? "active_menu_item_d2" : ""}>
                                  <Link to="/adsTxtView">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                      <g clip-path="url(#clip0_11459_19094)">
                                        <path d="M13.0556 1.5H2.94444C2.1467 1.5 1.5 2.1467 1.5 2.94444V13.0556C1.5 13.8533 2.1467 14.5 2.94444 14.5H13.0556C13.8533 14.5 14.5 13.8533 14.5 13.0556V2.94444C14.5 2.1467 13.8533 1.5 13.0556 1.5Z" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M5.11072 4.75H10.8885" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M5.11072 8H10.8885" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M5.11072 11.25H10.8885" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_11459_19094">
                                          <rect width="16" height="16" fill="white" />
                                        </clipPath>
                                      </defs>
                                    </svg>
                                    Ads.txt
                                  </Link>
                                </li>
                                <li className={location.pathname === "/appAdsTxtView" ? "active_menu_item_d2" : ""}>
                                  <Link to="/appAdsTxtView">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                      <g clip-path="url(#clip0_11459_19094)">
                                        <path d="M13.0556 1.5H2.94444C2.1467 1.5 1.5 2.1467 1.5 2.94444V13.0556C1.5 13.8533 2.1467 14.5 2.94444 14.5H13.0556C13.8533 14.5 14.5 13.8533 14.5 13.0556V2.94444C14.5 2.1467 13.8533 1.5 13.0556 1.5Z" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M5.11072 4.75H10.8885" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M5.11072 8H10.8885" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M5.11072 11.25H10.8885" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_11459_19094">
                                          <rect width="16" height="16" fill="white" />
                                        </clipPath>
                                      </defs>
                                    </svg>
                                    App Ads.txt
                                  </Link>
                                </li>
                                {checkRole !== "u_admin" &&
                                  <li className={location.pathname === "/inventorySettings" ? "active_menu_item_d2" : ""}>
                                    <Link to="/inventorySettings">
                                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <g clip-path="url(#clip0_11459_20470)">
                                          <path d="M8.00004 1.33333L1.33337 4.66666L8.00004 7.99999L14.6667 4.66666L8.00004 1.33333Z" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                          <path d="M1.33337 11.3333L8.00004 14.6667L14.6667 11.3333" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                          <path d="M1.33337 8L8.00004 11.3333L14.6667 8" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                        </g>
                                        <defs>
                                          <clipPath id="clip0_11459_20470">
                                            <rect width="16" height="16" fill="white" />
                                          </clipPath>
                                        </defs>
                                      </svg>
                                      Inventory Settings
                                    </Link>
                                  </li>
                                }
                              </>
                            }

                            {/* <li className="submenu_item"><Link to="#">Brand Safety <img src={HeaderArrow} className="hoverarrow" alt="" /></Link>

                            <div className="custom_drop_down_d3">
                              <ul className="">

                                <li className={location.pathname === "/brandSafety" ? "active_menu_item_d2" : ""}><Link to="/brandSafety" >IAB Category Blocking</Link></li>
                                <li className={location.pathname === "/basicSettings" ? "active_menu_item_d2" : ""}><Link to="/basicSettings">Basic Settings</Link></li>
                              </ul>
                            </div>
                          </li> */}
                            {checkRole !== "u_admin" &&
                              <>
                                <hr className="new_item_line_d2" />
                                <span className="menu_heading_with_divider">Brand Safety</span>

                                <li className={location.pathname === "/brandSafety" ? "active_menu_item_d2" : ""}>
                                  <Link to="/brandSafety" >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                      <g clip-path="url(#clip0_11459_20584)">
                                        <path d="M8 14.5C11.5899 14.5 14.5 11.5899 14.5 8C14.5 4.41015 11.5899 1.5 8 1.5C4.41015 1.5 1.5 4.41015 1.5 8C1.5 11.5899 4.41015 14.5 8 14.5Z" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M3.40442 3.40448L12.5954 12.5955" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_11459_20584">
                                          <rect width="16" height="16" fill="white" />
                                        </clipPath>
                                      </defs>
                                    </svg>
                                    IAB Category Blocking
                                  </Link>
                                </li>
                                <li className={location.pathname === "/basicSettings" ? "active_menu_item_d2" : ""}>
                                  <Link to="/basicSettings">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                      <path d="M3.11829 13.4545V9.21213" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                      <path d="M3.11829 6.78788V2.54547" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                      <path d="M7.9668 13.4545V8" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                      <path d="M7.9668 5.57577V2.54547" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                      <path d="M12.8152 13.4545V10.4242" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                      <path d="M12.8152 8V2.54547" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                      <path d="M1.30005 9.21213H4.9364" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                      <path d="M6.14856 5.57578H9.78491" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                      <path d="M10.9971 10.4242H14.6334" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                    Basic Settings
                                  </Link>
                                </li>
                                <hr className="new_item_line_d2" />
                                <span className="menu_heading_with_divider">My Account</span>
                                {/* <li className="submenu_item"><Link to="#">My Account <img src={HeaderArrow} className="hoverarrow" alt="" /></Link>

                            <div className="custom_drop_down_d3">
                              <ul className="">
                                <li className={location.pathname === "/generalSettings" ? "active_menu_item_d2" : ""}><Link to="/generalSettings" >General Settings</Link></li>
                                <li className={location.pathname === "/accountSettings" ? "active_menu_item_d2" : ""}><Link to="/accountSettings">Account Settings </Link></li>

                              </ul>
                            </div>
                          </li> */}
                                <li className={location.pathname === "/generalSettings" ? "active_menu_item_d2" : ""}>
                                  <Link to="/generalSettings" >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                      <path d="M13.3333 14V12.6667C13.3333 11.9594 13.0523 11.2811 12.5522 10.781C12.0521 10.281 11.3739 10 10.6666 10H5.33329C4.62605 10 3.94777 10.281 3.44767 10.781C2.94758 11.2811 2.66663 11.9594 2.66663 12.6667V14" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                      <path d="M8.00004 7.33333C9.4728 7.33333 10.6667 6.13943 10.6667 4.66667C10.6667 3.19391 9.4728 2 8.00004 2C6.52728 2 5.33337 3.19391 5.33337 4.66667C5.33337 6.13943 6.52728 7.33333 8.00004 7.33333Z" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                    General Settings
                                  </Link>
                                </li>
                                <li className={location.pathname === "/accountSettings" ? "active_menu_item_d2" : ""}>
                                  <Link to="/accountSettings">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                      <path d="M8 11C9.65685 11 11 9.65685 11 8C11 6.34315 9.65685 5 8 5C6.34315 5 5 6.34315 5 8C5 9.65685 6.34315 11 8 11Z" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                      <path d="M12.3375 5.04374C12.488 5.25916 12.6197 5.48708 12.7313 5.72499L14.35 6.62499C14.5521 7.53029 14.5543 8.46879 14.3563 9.37499L12.7313 10.275C12.6197 10.5129 12.488 10.7408 12.3375 10.9562L12.3688 12.8125C11.6827 13.4376 10.8708 13.9086 9.98752 14.1937L8.39377 13.2375C8.1316 13.2562 7.86843 13.2562 7.60627 13.2375L6.01877 14.1875C5.13271 13.9076 4.31808 13.4384 3.63127 12.8125L3.66252 10.9625C3.51331 10.7441 3.38165 10.5142 3.26877 10.275L1.65002 9.37499C1.44789 8.4697 1.44576 7.5312 1.64377 6.62499L3.26877 5.72499C3.38032 5.48708 3.51205 5.25916 3.66252 5.04374L3.63127 3.18749C4.3173 2.56235 5.12926 2.09137 6.01252 1.80624L7.60627 2.76249C7.86843 2.74374 8.1316 2.74374 8.39377 2.76249L9.98127 1.81249C10.8673 2.09243 11.682 2.56159 12.3688 3.18749L12.3375 5.04374Z" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                    Account Settings
                                  </Link>
                                </li>
                              </>
                            }

                          </ul>
                        </div>
                      </Link></li>


                      {(checkRole === "sa" || checkRole === "mobops") && (<li><Link className={location.pathname === "/freewheel" || location.pathname === "/pubmatic" || location.pathname === "/remoteFeedList" || location.pathname === "/campaignGam" || location.pathname === "/advertiser" || location.pathname === "/gamAutomation"
                        ? "active" : ""}><img src={partnersIcon} alt='demand' /> Demand
                        <img src={HeaderArrow} className="hoverarrow" alt="" />
                        <div className="custom_drop_down_d2">
                          <ul className="">


                            <li className={location.pathname === "/advertiser" ? "active_menu_item_d2" : ""}><Link to="/advertiser" >Advertisers</Link></li>
                            <hr className="new_item_line_d2" />
                            <li className={location.pathname === "/remoteFeedList" ? "active_menu_item_d2" : ""}><Link to="/remoteFeedList" >Remote Feeds</Link></li>
                            <hr className="new_item_line_d2" />
                            <li className={location.pathname === "/freewheel" ? "active_menu_item_d2" : ""}><Link to="/freewheel">Freewheel</Link></li>
                            <li className={location.pathname === "/pubmatic" ? "active_menu_item_d2" : ""}><Link to="/pubmatic">Pubmatic</Link></li>
                            <li className={location.pathname === "/campaignGam" ? "active_menu_item_d2" : ""}><Link to="/campaignGam">GAM</Link></li>
                            <li className={location.pathname === "/gamAutomation" ? "active_menu_item_d2" : ""}><Link to="/gamAutomation">GAM Automation</Link></li>
                          </ul>
                        </div>
                      </Link></li>)}



                      {(checkRole === "sa" || checkRole === "mobops") && (<li><Link className={(location.pathname === "/appBundleListGam" || location.pathname === "/excludedCategoryListGam" || location.pathname === "/extendedUserListGam" || location.pathname === "/ipListGam")
                        ? "active" : ""}><img src={ListManagerIcon} alt='demand' /> List Manager
                        <img src={HeaderArrow} className="hoverarrow" alt="" />
                        <div className="custom_drop_down_d2">
                          <ul className="">
                            <>
                              <li className={location.pathname === "/appBundleListGam" ? "active_menu_item_d2" : ""}><Link to="/appBundleListGam" >App Bundle List</Link></li>
                              <li className={location.pathname === "/excludedCategoryListGam" ? "active_menu_item_d2" : ""}><Link to="/excludedCategoryListGam">Excluded Category List</Link></li>
                              <li className={location.pathname === "/extendedUserListGam" ? "active_menu_item_d2" : ""}><Link to="/extendedUserListGam">Extended User List</Link></li>
                              <li className={location.pathname === "/ipListGam" ? "active_menu_item_d2" : ""}><Link to="/ipListGam">IP List</Link></li>
                            </>
                          </ul>
                        </div>
                      </Link></li>)}




                      {/* {(checkRole === "sa" || checkRole === "mobops") && (<li><Link className={location.pathname === "/reporting" || location.pathname === "/savedReports" ? "active" : ""}><img src={reportIcon2} alt='listManager' /> Report
                      <img src={HeaderArrow} className="hoverarrow" alt="" />
                      <div className="custom_drop_down_d2">
                        <ul className="">
                          <li className={location.pathname === "/savedReports" ? "active_menu_item_d2" : ""}><Link to="/savedReports" >Saved Reports</Link></li>
                          <li className={location.pathname === "/reporting" ? "active_menu_item_d2" : ""}><Link to="/reporting">Reporting</Link></li>
                        </ul>
                      </div>
                    </Link></li>)} */}



                      {(checkRole === "sa" || checkRole === "mobops" || checkRole === "am" || (checkRole === "admin" || checkRole === "u_admin")) && (
                        <li><Link className={location.pathname === "/knowledgeBase" || location.pathname === "/upr" || location.pathname === "/healthcenter" || location.pathname === "/userList" || location.pathname === "/userSyncReport" ? "active" : ""}><img src={adminIcon} alt='admin' /> Admin
                          <img src={HeaderArrow} className="hoverarrow" alt="" />
                          <div className="custom_drop_down_d2">
                            {(checkRole === "admin" || checkRole === "u_admin" || checkRole === "am") ?
                              <ul className="">

                                <li className={location.pathname === "/userList" ? "active_menu_item_d2" : ""}>
                                  <Link to="/userList" >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                      <g clip-path="url(#clip0_11624_7868)">
                                        <path d="M11.3334 14V12.6667C11.3334 11.9594 11.0524 11.2811 10.5523 10.781C10.0522 10.281 9.37393 10 8.66669 10H3.33335C2.62611 10 1.94783 10.281 1.44774 10.781C0.947639 11.2811 0.666687 11.9594 0.666687 12.6667V14" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M5.99998 7.33333C7.47274 7.33333 8.66665 6.13943 8.66665 4.66667C8.66665 3.19391 7.47274 2 5.99998 2C4.52722 2 3.33331 3.19391 3.33331 4.66667C3.33331 6.13943 4.52722 7.33333 5.99998 7.33333Z" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M15.3333 14V12.6667C15.3329 12.0758 15.1362 11.5019 14.7742 11.0349C14.4122 10.5679 13.9054 10.2344 13.3333 10.0867" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M10.6667 2.08667C11.2403 2.23354 11.7487 2.56714 12.1118 3.03488C12.4748 3.50262 12.6719 4.07789 12.6719 4.67C12.6719 5.26212 12.4748 5.83739 12.1118 6.30513C11.7487 6.77287 11.2403 7.10647 10.6667 7.25334" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_11624_7868">
                                          <rect width="16" height="16" fill="white" />
                                        </clipPath>
                                      </defs>
                                    </svg>
                                    User List
                                  </Link>
                                </li>
                              </ul>
                              :
                              <ul className="">

                                <li className={location.pathname === "/userList" ? "active_menu_item_d2" : ""}>
                                  <Link to="/userList" >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                      <g clip-path="url(#clip0_11624_7868)">
                                        <path d="M11.3334 14V12.6667C11.3334 11.9594 11.0524 11.2811 10.5523 10.781C10.0522 10.281 9.37393 10 8.66669 10H3.33335C2.62611 10 1.94783 10.281 1.44774 10.781C0.947639 11.2811 0.666687 11.9594 0.666687 12.6667V14" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M5.99998 7.33333C7.47274 7.33333 8.66665 6.13943 8.66665 4.66667C8.66665 3.19391 7.47274 2 5.99998 2C4.52722 2 3.33331 3.19391 3.33331 4.66667C3.33331 6.13943 4.52722 7.33333 5.99998 7.33333Z" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M15.3333 14V12.6667C15.3329 12.0758 15.1362 11.5019 14.7742 11.0349C14.4122 10.5679 13.9054 10.2344 13.3333 10.0867" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M10.6667 2.08667C11.2403 2.23354 11.7487 2.56714 12.1118 3.03488C12.4748 3.50262 12.6719 4.07789 12.6719 4.67C12.6719 5.26212 12.4748 5.83739 12.1118 6.30513C11.7487 6.77287 11.2403 7.10647 10.6667 7.25334" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_11624_7868">
                                          <rect width="16" height="16" fill="white" />
                                        </clipPath>
                                      </defs>
                                    </svg>
                                    User List
                                  </Link>
                                </li>


                                <li className={location.pathname === "/userSyncReport" ? "active_menu_item_d2" : ""}>
                                  <Link to="/userSyncReport" >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                      <path d="M14.3874 3.99497C14.7561 4.85605 14.8464 5.81089 14.6455 6.72582C14.4447 7.64075 13.9627 8.46997 13.2671 9.09737C12.5716 9.72477 11.6972 10.119 10.7665 10.2247C9.83577 10.3305 8.89526 10.1426 8.07664 9.68726L4.13421 14.2551C3.81736 14.572 3.38762 14.75 2.93953 14.75C2.49144 14.75 2.0617 14.572 1.74485 14.2551C1.428 13.9383 1.25 13.5086 1.25 13.0605C1.25 12.6124 1.428 12.1826 1.74485 11.8658L6.31274 7.92336C5.85742 7.10474 5.66949 6.16423 5.77527 5.2335C5.88104 4.30277 6.27523 3.42842 6.90263 2.73285C7.53003 2.03729 8.35925 1.55533 9.27418 1.35446C10.1891 1.1536 11.144 1.24387 12.005 1.61265L9.05347 4.55718L9.45404 6.54596L11.4428 6.94653L14.3874 3.99497Z" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                    Tools
                                  </Link>
                                </li>


                                <li className={location.pathname === "/healthcenter" ? "active_menu_item_d2" : ""}>
                                  <Link to="/healthcenter" >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                      <path d="M1.28003 8.00001H4.08003L5.20003 6.32001L7.44003 9.68001L8.56003 8.00001H10.24" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                      <path d="M1.007 5.76C1 5.669 1 5.571 1 5.48C1 4.63852 1.29155 3.82303 1.82503 3.17228C2.35852 2.52153 3.101 2.07572 3.92614 1.91069C4.75128 1.74566 5.6081 1.87161 6.35084 2.26712C7.09359 2.66263 7.67635 3.30325 8 4.08C8.32365 3.30325 8.90641 2.66263 9.64915 2.26712C10.3919 1.87161 11.2487 1.74566 12.0739 1.91069C12.899 2.07572 13.6415 2.52153 14.175 3.17228C14.7085 3.82303 15 4.63852 15 5.48C15 10.24 8 14.16 8 14.16C8 14.16 5.207 12.592 3.149 10.24" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                    Health Center
                                  </Link>
                                </li>

                                <li className={location.pathname === "/knowledgeBase" ? "active_menu_item_d2" : ""}>
                                  <Link to="/knowledgeBase" >

                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M1.33331 2H5.33331C6.04056 2 6.71883 2.28095 7.21893 2.78105C7.71903 3.28115 7.99998 3.95942 7.99998 4.66667V14C7.99998 13.4696 7.78927 12.9609 7.41419 12.5858C7.03912 12.2107 6.53041 12 5.99998 12H1.33331V2Z" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                      <path d="M14.6667 2H10.6667C9.95942 2 9.28115 2.28095 8.78105 2.78105C8.28095 3.28115 8 3.95942 8 4.66667V14C8 13.4696 8.21071 12.9609 8.58579 12.5858C8.96086 12.2107 9.46957 12 10 12H14.6667V2Z" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>

                                    Knowledge Base
                                  </Link>
                                </li>
                                <li className={location.pathname === "/upr" ? "active_menu_item_d2" : ""}>
                                  <Link to="/upr" >

                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                      <path d="M2.75 12.75C3.7165 12.75 4.5 11.9665 4.5 11C4.5 10.0335 3.7165 9.25 2.75 9.25C1.7835 9.25 1 10.0335 1 11C1 11.9665 1.7835 12.75 2.75 12.75Z" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                      <path d="M12.5 2.5L15 5L12.5 7.5" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                      <path d="M4.5 11H5C5.79565 11 6.55871 10.6839 7.12132 10.1213C7.68393 9.55871 8 8.79565 8 8C8 7.20435 8.31607 6.44129 8.87868 5.87868C9.44129 5.31607 10.2044 5 11 5H15" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>

                                    UPR Mapper
                                  </Link>
                                </li>
                                {/* 
                            {(checkRole === "sa" || checkRole === "mobops") && (<li><Link to="/userSyncReport" className={location.pathname === "/userSyncReport" ? "active" : ""}><img src={ToolsIcon} alt='userSyncReport' /> Tools</Link></li>)} */}


                                {/* <li className={location.pathname === "/tagHistory" ? "active_menu_item_d2" : ""}><Link to="/tagHistory">Tagging History</Link></li>
                            <li className={location.pathname === "/domainHistory" ? "active_menu_item_d2" : ""}><Link to="/domainHistory">Domain History</Link></li> */}
                              </ul>
                            }

                          </div>
                        </Link>
                        </li>)}

                    </ul>
                  </nav>
                </Col>
                <Col span={2} className='container_box--end p-0'>
                  <div className="user_dropdown">
                    <div className='user_dropdown--symbol'>
                      <span>{name?.length > 0 ? name?.charAt(0)?.toUpperCase() : ""}</span>
                      <div className="user_dropdown--menu">
                        <div className="user_dropdown--menu-header">
                          <h4 className='heading'>{name.toUpperCase()}</h4>
                          <p className='text'>{email.toLowerCase()}</p>
                        </div>
                        {/* <div className="user_dropdown--menu-body">
                        <Link className="menu_item" to="/profile"><img src={settingIcon} alt="USP" /> My Profile</Link>
                      </div> */}

                        <div className="user_dropdown--menu-footer py-0">
                          <button className="menu_item" onClick={logout}><img src={logoutIcon} alt="USP" /> Logout</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
            {(checkRole === "admin" || checkRole === "u_admin") && msgInventory === 0 &&
              <Link to="/inventory" className='upload_here_txt_btn'>
                <div className='alert_div_for_publisher'>
                  <div className='profile_review_alert_div --dashboard_design'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
                      <path d="M18 33C26.2843 33 33 26.2843 33 18C33 9.71573 26.2843 3 18 3C9.71573 3 3 9.71573 3 18C3 26.2843 9.71573 33 18 33Z" stroke="#894B00" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M3 18H33" stroke="#894B00" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M18 3C21.7519 7.10753 23.8841 12.4381 24 18C23.8841 23.5619 21.7519 28.8925 18 33C14.2481 28.8925 12.1159 23.5619 12 18C12.1159 12.4381 14.2481 7.10753 18 3V3Z" stroke="#894B00" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>

                    <div className='d-flex align-items-center justify-content-between w-100'>
                      <div className=''>
                        <h3>Add your inventory to move toward activation.</h3>
                        <p>Your account is approved and ready. Complete your Sites & Apps details so our team can begin reviewing and preparing your inventory for activation.</p>
                      </div>
                      <div className='d-flex align-items-end gap_4'>
                        <p className='upload_inventory_txt'>
                          Upload inventory
                        </p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                          <path d="M4.10744 10.0002H15.8926" stroke="#7434DB" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M10 4.1076L15.8926 10.0002L10 15.8927" stroke="#7434DB" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
            }
          </header >


        </>
      )}


    </>
  );
};

export default Header;
